
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.906 21.539C6.641 14.009 6.614 5.164 6.83 0l4.134.142c-.224 5.377-.18 14.858.125 22.528.143-.335.274-.638.386-.889.115-.26.26-.578.388-.791.76-1.261 1.229-2.396 1.715-3.573.143-.346.287-.695.44-1.052.659-1.53 1.468-3.135 3.065-4.578L20 14.45c-.976.881-1.532 1.892-2.129 3.28-.118.277-.24.572-.368.884-.498 1.207-1.096 2.659-2.011 4.178l-.008.017c-.02.042-.075.156-.175.381a85.38 85.38 0 00-.457 1.054l-.118.276c-.336.784-.739 1.727-1.15 2.64-.454 1.01-.944 2.044-1.386 2.815-.21.367-.466.777-.753 1.102-.129.147-.383.417-.763.623-.41.223-1.35.546-2.32 0-.568-.32-.991-.81-1.265-1.16-.313-.4-.624-.875-.923-1.376-.6-1.005-1.237-2.252-1.844-3.512a156.362 156.362 0 01-1.726-3.74l-.315-.704a116.06 116.06 0 00-.947-2.084c-.208-.436-.563-1.53-.818-2.331a144.158 144.158 0 01-.481-1.542L0 15.11l1.994-.5 1.994-.5.04.134a149.947 149.947 0 00.47 1.505c.137.43.28.869.404 1.233.062.183.118.34.163.463.051.137.075.19.075.19.26.546.604 1.316.992 2.182a791.495 791.495 0 00.774 1.72z","fill":"#fff"}})])
          )
        }
      }
    